import { useGetIncidents, useGetMonitoringSummary } from '@/features/monitoring/monitoring.queries';

/**
 * Controller hook for the Monitoring dashboard page.
 * Combines the live health summary and the incidents feed.
 */
export const useMonitoringPage = () => {
  const summaryQuery = useGetMonitoringSummary();
  const incidentsQuery = useGetIncidents();

  const incidents = incidentsQuery.data?.items ?? [];

  const isLoading = summaryQuery.isLoading || incidentsQuery.isLoading;
  const isError = summaryQuery.isError || incidentsQuery.isError;

  return {
    summary: summaryQuery.data,
    incidents,
    isLoading,
    isError,
  };
};
